import * as React from 'react';

import ISettings from './ISettings';
import { IInputChangeEventHandler } from '../../../../interfaces';

interface IProps {
    settings: ISettings,
    handleChange: IInputChangeEventHandler,
}

export default class Editor extends React.Component<IProps, void> {
    static propTypes = {
        settings: React.PropTypes.object.isRequired,
        handleChange: React.PropTypes.func.isRequired
    };

    render() {
        return (
            <div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/widget/basic/pagebreak/Editor.tsx